module.exports = __webpack_public_path__ + "static/media/4.2e8436eb.png";